var app = angular.module('leonardo');

var RedirectionRun = function($rootScope, NavigationService, CookieService, $timeout, PermissionService, NotificationService, StatsigService, IoShareRedirectService) {

  var authDataLoadingPromise = null;
  var bypassShareRedirect = false;

  function getAuthDataPromise() {
    if (!authDataLoadingPromise) {
      authDataLoadingPromise = PermissionService.authDataService.getData().then(function(authData) {
        PermissionService.authDataService.authData = authData;
        resetBreaker();
        return authData;
      }).finally(function() {
        authDataLoadingPromise = null;
      });
    }
    return authDataLoadingPromise;
  }

  // ui-router re-fires $stateChangeStart when we re-navigate after the gate
  // says "stay on legacy"; this flag prevents an intercept loop.
  function resumeShareNavigation(toState, toParams) {
    bypassShareRedirect = true;
    return NavigationService.redirectToState({ url: toState.name, params: toParams })
      .finally(function() {
        bypassShareRedirect = false;
      });
  }

  var authDataFailedToken = null;
  var authDataFailedAt = 0;
  var authDataNoticeAt = 0;
  var AUTH_DATA_RETRY_COOLDOWN_MS = 30000;

  function tripBreaker() {
    authDataFailedToken = localStorage.getItem('jwt_token');
    authDataFailedAt = Date.now();
  }

  function resetBreaker() {
    authDataFailedToken = null;
    authDataFailedAt = 0;
    authDataNoticeAt = 0;
  }

  // The breaker cancels the navigation silently, which reads as a dead click.
  // Throttled to the cooldown window so a burst of blocked navigations produces
  // one message rather than one per click.
  function notifyNavigationBlocked() {
    var now = Date.now();
    if (authDataNoticeAt && (now - authDataNoticeAt) < AUTH_DATA_RETRY_COOLDOWN_MS) {
      return;
    }
    authDataNoticeAt = now;
    NotificationService.notify(
      'warning',
      'Unable to load your account',
      'We could not load your account information. Please refresh the page or log in again.'
    );
  }

  // A 401 on any authenticated call means further attempts with this token will
  // fail too, so trip on the first one instead of waiting for the whole
  // auth-data batch to reject.
  $rootScope.$on('auth-failure:unauthorized', tripBreaker);
  $rootScope.$on('iframe-auth:token-received', resetBreaker);
  $rootScope.$on('user:logout', resetBreaker);

  function getInIframeFlag() {
    if (typeof $rootScope.isInIframe !== 'undefined') {
      return !!$rootScope.isInIframe;
    }
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
    var maintenance = CookieService.getCookie('leo_maintenance');
    if ((toState.name === 'maintenance') || (maintenance && toState.name !== 'maintenance')) {
      return $timeout(NavigationService.goToMaintenance, 0);
    }
    else {
      var inIframe = getInIframeFlag();
      var authenticated = !isNull(localStorage.getItem("jwt_token"));
      if (!toState.relative) {
        var ioShareUrl = bypassShareRedirect ? null :
          IoShareRedirectService.getIoUrlForState(toState.name, toParams);

        if (authenticated && isEmpty(PermissionService.authDataService.authData)) {
          event.preventDefault();

          var currentToken = localStorage.getItem('jwt_token');
          if (!authDataLoadingPromise &&
              authDataFailedToken === currentToken &&
              (Date.now() - authDataFailedAt) < AUTH_DATA_RETRY_COOLDOWN_MS) {
            notifyNavigationBlocked();
            return;
          }

          return getAuthDataPromise().then(function() {
            var url_redirect = localStorage.getItem('url_redirect');
            if (inIframe && url_redirect) {
              localStorage.removeItem('url_redirect');
              return NavigationService.redirectToState(JSON.parse(url_redirect));
            }
            if (ioShareUrl && !inIframe) {
              return StatsigService.checkGate('beta_forced_opt_in').then(function(forced) {
                if (forced) {
                  IoShareRedirectService.redirect(ioShareUrl);
                  return;
                }
                return resumeShareNavigation(toState, toParams);
              });
            }
            return NavigationService.redirectToState({ url: toState.name, params: toParams });
          }).catch(function() {
            tripBreaker();
            if (inIframe) {
              localStorage.setItem('url_redirect', JSON.stringify({url: toState.name, params: toParams}));
            } else if (authenticated && !isEmpty(PermissionService.authDataService.authData)) {
              return NavigationService.goToHome(PermissionService.authDataService.authData);
            }
            return NavigationService.goToUserAnonymousHome();
          });
        }

        // Warm path: authData already loaded (in-app navigation to a share
        // state). Same forced-migration check as the fresh-load branch above.
        if (ioShareUrl && authenticated && !inIframe) {
          event.preventDefault();
          return StatsigService.checkGate('beta_forced_opt_in').then(function(forced) {
            if (forced) {
              IoShareRedirectService.redirect(ioShareUrl);
              return;
            }
            return resumeShareNavigation(toState, toParams);
          }).catch(function() {
            // Gate or resume failure: land on the legacy share state rather
            // than swallowing the transition.
            return resumeShareNavigation(toState, toParams);
          });
        }

        // In iframe: only redirect away from login/public pages, don't force navigation to home from protected pages
        var shouldRedirect = authenticated && toState.public;
        if (inIframe && shouldRedirect) {
          // In iframe, redirect using url_redirect if available, otherwise redirect to home
          event.preventDefault();
          var url_redirect = localStorage.getItem('url_redirect');
          if (url_redirect) {
            localStorage.removeItem('url_redirect');
            return NavigationService.redirectToState(JSON.parse(url_redirect));
          }
          return NavigationService.goToHome(PermissionService.authDataService.authData);
        }
        else if (!inIframe && (shouldRedirect || toState.name === 'login-redirection')) {
          // Not in iframe, use normal redirect logic
          event.preventDefault();
          var url_redirect = localStorage.getItem('url_redirect');
          if (url_redirect) {
            localStorage.removeItem('url_redirect');
            return NavigationService.redirectToState(JSON.parse(url_redirect));
          }
          return NavigationService.goToHome(PermissionService.authDataService.authData);
        }
        if (!authenticated && !toState.public) {
          event.preventDefault();
          localStorage.setItem('url_redirect', JSON.stringify({url: toState.name, params: toParams}));
          NotificationService.notify('info', 'Login Required', 'Please log in to access this page. You will be redirected after login.');
          return NavigationService.goToUserAnonymousHome();
        }
        if (toState.redirectTo) {
          event.preventDefault();
          if (angular.isFunction(toState.redirectTo)) {
            return NavigationService.redirectToState({ url:toState.redirectTo(PermissionService), params: toParams });
          }
          else {
            return NavigationService.redirectToState({ url:toState.redirectTo, params: toParams });
          }
        }
        if (!PermissionService.permissionViewAvailable(toState.name)) {
          event.preventDefault();
          return NavigationService.goToHome(PermissionService.authDataService.authData);
        }
      }
    }
  });
};

app.run(['$rootScope', 'NavigationService', 'CookieService', '$timeout', 'PermissionService', 'NotificationService', 'StatsigService', 'IoShareRedirectService', RedirectionRun]);
